import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const FirebaseConfig = {
  apiKey: 'AIzaSyAxe2m8klpTAQ4Y_uDogdfhOAGh4Z-6Irw',
  authDomain: 'kingrecharge-693ac.firebaseapp.com',
  projectId: 'kingrecharge-693ac',
  storageBucket: 'kingrecharge-693ac.firebasestorage.app',
  messagingSenderId: '559907618795',
  appId: '1:559907618795:web:94a3cb33da931b255863ae',
}
const tokenConfig = {
  vapidKey:
    'BAfePcoww4Z66DPVDW5gc6xqiEKISFaWLeeRyEUry0xzc_upLGI0k9Qw6IezWfXcIY2JDbIBPsEmnJHGRIruZeU',
}

let app, messaging

class FcmNotification {
  static init() {
    app = initializeApp(FirebaseConfig)
    messaging = getMessaging(app)
  }
  static setNotificationHandler(notificationHandler) {
    onMessage(messaging, notificationHandler)
  }

  static async getDeviceToken() {
    const token = await getToken(messaging, tokenConfig).catch(error => {
      console.error(error)
      return null
    })
    return token || ''
  }
}

export { FcmNotification }
